// polyp-*/src/firebase.js
import { initializeApp } from "firebase/app";
import {
  getAuth,
  GoogleAuthProvider,
  OAuthProvider,
} from "firebase/auth";
import { getFirestore } from "firebase/firestore";

const firebaseConfig = {
  apiKey:               process.env.REACT_APP_FIREBASE_API_KEY,
  authDomain:           process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
  projectId:            process.env.REACT_APP_FIREBASE_PROJECT_ID,
  storageBucket:        process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
  messagingSenderId:    process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
  appId:                process.env.REACT_APP_FIREBASE_APP_ID,
  measurementId:        process.env.REACT_APP_FIREBASE_MEASUREMENT_ID,
};

const firebaseApp = initializeApp(firebaseConfig);
export const auth = getAuth(firebaseApp);
export default firebaseApp; // Export the initialized app if needed elsewhere
export const db   = getFirestore(firebaseApp);

// OAuth provider singletons — Polyp uses Google + Apple. Construct once so
// subsequent linkWithCredential / signInWithPopup calls reuse the same scopes.
export const googleProvider = new GoogleAuthProvider();
googleProvider.setCustomParameters({ prompt: "select_account" });

export const appleProvider = new OAuthProvider("apple.com");
appleProvider.addScope("email");
appleProvider.addScope("name");